export default __webpack_public_path__ + "static/media/Soupline_0_lowdef.2f4ff934.png";